const BLOCKED_NEWS_SOURCE = 'the washington post';

const BLOCKED_NEWS_DOMAINS = [
  'nature.com',
  'sciencedirect.com',
  'journals.ssu.ac.ir',
  'jims.mui.ac.ir',
  'lww.com',
  'washingtonpost.com',
];

const normalize = (value = '') => value.toString().trim().toLowerCase();

const isBlockedDomain = (hostname = '') => {
  const host = normalize(hostname).replace(/^www\./, '');
  return BLOCKED_NEWS_DOMAINS.some(
    (domain) => host === domain || host.endsWith(`.${domain}`),
  );
};

const getHostname = (url = '') => {
  try {
    return new URL(url).hostname || '';
  } catch (error) {
    return '';
  }
};

export const isBlockedNewsItem = (item = {}) => {
  const source = normalize(item?.source);
  if (source === BLOCKED_NEWS_SOURCE) return true;

  const hostname = getHostname(item?.url);
  return isBlockedDomain(hostname);
};

export const filterBlockedNewsItems = (list = []) => {
  if (!Array.isArray(list)) return [];
  return list.filter((item) => !isBlockedNewsItem(item));
};

export const countBlockedNewsItems = (list = []) => {
  if (!Array.isArray(list)) return 0;
  return list.filter((item) => isBlockedNewsItem(item)).length;
};

